import { RecentSearchItem, RecentSearchScope } from '#/components/AdvancedSearch/types'
import { useCompanySlug } from '#/store/ducks/company'
import { useFarmSlug } from '#/store/ducks/farm'
import useAppContext from '#/store/hooks/useAppContext'

const LOCAL_STORAGE_KEY = 'global-search-recent'
const MAX_RECENT_ITEMS = 5

export function useRecentSearchScope(): RecentSearchScope {
  const context = useAppContext()
  const farmSlug = useFarmSlug()
  const companySlug = useCompanySlug()

  if (context === 'farm') return { context, tenantSlug: farmSlug }
  if (context === 'company') return { context, tenantSlug: companySlug }
  return { context }
}

function getStorageKey(scope: RecentSearchScope): string {
  return scope.tenantSlug
    ? `${LOCAL_STORAGE_KEY}:${scope.context}:${scope.tenantSlug}`
    : `${LOCAL_STORAGE_KEY}:${scope.context}`
}

function getStoredItems(scope: RecentSearchScope): RecentSearchItem[] {
  try {
    const stored = window.localStorage.getItem(getStorageKey(scope))
    const parsedItems = stored ? JSON.parse(stored) : []
    return Array.isArray(parsedItems) ? parsedItems : []
  } catch {
    return []
  }
}

export function getRecentSearches(scope: RecentSearchScope): RecentSearchItem[] {
  return getStoredItems(scope)
}

export function addRecentSearch(item: RecentSearchItem, scope: RecentSearchScope): void {
  const currentItems = getStoredItems(scope).filter(existingItem => existingItem.key !== item.key)
  const updatedItems = [item, ...currentItems].slice(0, MAX_RECENT_ITEMS)
  try {
    window.localStorage.setItem(getStorageKey(scope), JSON.stringify(updatedItems))
  } catch {
    // localStorage pode estar indisponível em modo privado ou com a quota excedida
  }
}

export function clearRecentSearches(scope: RecentSearchScope): void {
  try {
    window.localStorage.removeItem(getStorageKey(scope))
  } catch {
    // localStorage pode estar indisponível em modo privado ou com a quota excedida
  }
}
